import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import _JSON$stringify from "@babel/runtime-corejs3/core-js-stable/json/stringify";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/trim";
import _setTimeout from "@babel/runtime-corejs3/core-js-stable/set-timeout";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
import { navigate } from "@reach/router";
import { RaiseColors, makeStyles, useMediaQuery, useTheme, Typography } from "componentLibrary";
import RaiseButton, { ButtonVariantEnum, ButtonSizeEnum } from "componentLibrary/MuiComponentWrappers/Button/RaiseButton";
import GlobalSnackbar from "components/GlobalMessageSnackbar/GlobalSnackbar";
import queryString from "query-string";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import * as Yup from "yup";
import { getRedirectUrl } from "./loginUtils";
import LoginFormContentContainer from "./LoginFormContentContainer";
import { IntegrationServicesEnum, IntegrationLoginViews, OTPErrorCodeEnum } from "utils/Enums";
import { sendMessageToIosApp, MessageHandlerNames } from "core/Window/WebkitMessageHandler";
import WorkplaceLanding from "./WorkplaceLanding";
import WorkplaceAlternateSignIns from "./WorkplaceAlternateSignIns";
import WorkplaceLoginFormWithOTP from "./WorkplaceLoginFormWithOTP";
import WorkplaceOTPVerification from "./WorkplaceOTPVerification";
import ErrorBoundary from "components/ErrorBoundary";
import Cookies from "js-cookie";
import { WorkplaceOSLoginContainer } from "./WorkplaceOSLoginCommon";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var REQUEST_OTP_ENDPOINT = "/ajax/accounts/request_otp";
var VERIFY_OTP_ENDPOINT = "/ajax/accounts/verify_otp";
var LOGIN_ENDPOINT = "/ajax/accounts/login";
var DEFAULT_ERROR_MESSAGE = "Oops ... Seems like there's an error. Please check for typos and try again.";
var UNEXPECTED_ERROR_MESSAGE = "An unexpected error has occurred";
var FAILED_TO_GENERATE_OTP_MESSAGE = "Failed to generate OTP. Please try again.";
var INVALID_VERIFICATION_CODE_MESSAGE = "Invalid verification code. Please check the code and try again, or request a new one.";
var ACCOUNT_LOCKED_MESSAGE = 'Account Locked: Too many unsuccessful sign-in attempts. Please wait 15 minutes, or reset your password using "Forgot Password?';
var getHeaders = function getHeaders() {
  return {
    "Content-Type": "application/json",
    "X-CSRFToken": Cookies.get("csrftoken") || ""
  };
};
var useOTPErrorFallbackStyles = makeStyles(function () {
  return {
    container: {
      textAlign: "center"
    },
    title: {
      marginBottom: "16px"
    },
    message: {
      marginBottom: "24px"
    }
  };
});
export var OTPErrorFallback = function OTPErrorFallback() {
  var theme = useTheme();
  var isMobile = useMediaQuery(theme.breakpoints.down("smMd"));
  var classes = useOTPErrorFallbackStyles();
  return /*#__PURE__*/_jsxs(WorkplaceOSLoginContainer, {
    className: classes.container,
    children: [/*#__PURE__*/_jsx(Typography, {
      variant: "h3",
      weight: "semibold",
      color: RaiseColors.jllNeutral100,
      className: classes.title,
      children: "Something went wrong"
    }), /*#__PURE__*/_jsx(Typography, {
      variant: "paragraph_medium",
      color: RaiseColors.grayscale900,
      className: classes.message,
      children: "We encountered an error while verifying your code. Please try again or go back to sign in."
    }), /*#__PURE__*/_jsx(RaiseButton, {
      variant: ButtonVariantEnum.primary,
      size: isMobile ? ButtonSizeEnum.medium : ButtonSizeEnum.large,
      onClick: function onClick() {
        return window.location.reload();
      },
      setToFill: true,
      children: "Try Again"
    })]
  });
};
var useStyles = function useStyles() {
  var theme = useTheme();
  return makeStyles(function () {
    return {
      container: _defineProperty(_defineProperty(_defineProperty({
        height: "100%",
        width: "100%"
      }, theme.breakpoints.up("md"), {
        display: "flex"
      }), theme.breakpoints.down("md"), {
        paddingTop: 32,
        display: "block"
      }), "backgroundColor", RaiseColors.neutral200),
      loginContentContainer: _defineProperty({
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: RaiseColors.neutral200,
        margin: "auto"
      }, theme.breakpoints.up("md"), {
        width: "60%"
      }),
      loginContentImage: _defineProperty(_defineProperty({
        height: 48,
        width: 268
      }, theme.breakpoints.down("smMd"), {
        width: 178,
        height: 32
      }), "marginBottom", 32),
      stockImage: {
        height: "100%",
        width: "40%",
        objectFit: "cover",
        backgroundColor: RaiseColors.midnight
      }
    };
  });
};
var WorkplaceLogin = function WorkplaceLogin() {
  var classes = useStyles()();
  var location = useLocation();
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    loading = _React$useState2[0],
    setLoading = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    otpButtonLoading = _React$useState4[0],
    setOtpButtonLoading = _React$useState4[1];
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    isError = _React$useState6[0],
    setIsError = _React$useState6[1];
  var _React$useState7 = React.useState(DEFAULT_ERROR_MESSAGE),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    errorMessage = _React$useState8[0],
    setErrorMessage = _React$useState8[1];
  var _React$useState9 = React.useState(""),
    _React$useState0 = _slicedToArray(_React$useState9, 2),
    snackBarMessage = _React$useState0[0],
    setSnackBarMessage = _React$useState0[1];
  var _React$useState1 = React.useState(false),
    _React$useState10 = _slicedToArray(_React$useState1, 2),
    isBannerDisplayed = _React$useState10[0],
    setIsBannerDisplayed = _React$useState10[1];
  var _React$useState11 = React.useState(IntegrationLoginViews.CHECK_EMAIL.value),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    view = _React$useState12[0],
    setView = _React$useState12[1];
  var _React$useState13 = React.useState([]),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    loginMethods = _React$useState14[0],
    setLoginMethods = _React$useState14[1];
  var _React$useState15 = React.useState(""),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    email = _React$useState16[0],
    setEmail = _React$useState16[1];
  var emailRef = React.useRef("");
  var _React$useState17 = React.useState(queryString.parse(location.search)),
    _React$useState18 = _slicedToArray(_React$useState17, 2),
    queryParams = _React$useState18[0],
    setQueryParams = _React$useState18[1];
  var _React$useState19 = React.useState(""),
    _React$useState20 = _slicedToArray(_React$useState19, 2),
    otpEmail = _React$useState20[0],
    setOtpEmail = _React$useState20[1];
  var _React$useState21 = React.useState(false),
    _React$useState22 = _slicedToArray(_React$useState21, 2),
    showOTPVerification = _React$useState22[0],
    setShowOTPVerification = _React$useState22[1];
  var _React$useState23 = React.useState(null),
    _React$useState24 = _slicedToArray(_React$useState23, 2),
    lastResendTime = _React$useState24[0],
    setLastResendTime = _React$useState24[1];
  var theme = useTheme();
  var isMobile = useMediaQuery(theme.breakpoints.down("lg"));
  useEffect(function () {
    // if the banner has already been displayed, don't show it again
    if (!isBannerDisplayed) {
      var _ref, _ref2, _ref3;
      var error = (_ref = queryParams === null || queryParams === void 0 ? void 0 : queryParams.error) !== null && _ref !== void 0 ? _ref : null;
      var idp = (_ref2 = queryParams === null || queryParams === void 0 ? void 0 : queryParams.idp) !== null && _ref2 !== void 0 ? _ref2 : null;
      var message = (_ref3 = queryParams === null || queryParams === void 0 ? void 0 : queryParams.message) !== null && _ref3 !== void 0 ? _ref3 : null;
      if (message) {
        // Handle direct message parameter (e.g., expired activation link)
        setIsBannerDisplayed(true);
        setSnackBarMessage(message);
        setIsError(true);
        setErrorMessage(message);
      } else if (error) {
        var _message;
        switch (error) {
          case "1":
          case "2":
          case "3":
          case "4":
          default:
            _message = "Login wth ".concat(idp, " failed. Please try again later");
            break;
          case "5":
            _message = "User does not exist in ".concat(idp, ". Please contact customer support");
            break;
          case "6":
            _message = "Email does not match with logged in ".concat(idp, " user's email");
            break;
          case "7":
            _message = "failed to create user in Raise. Please try again later";
            break;
        }
        setIsBannerDisplayed(true);
        setSnackBarMessage(_message);
      }
    }
    //  banner was displayed, now remove the query params from the url so it doesn't show again
    if (isBannerDisplayed) {
      setIsBannerDisplayed(false);
      setQueryParams({});
      navigate("".concat(location.pathname));
    }
  }, [location, queryParams, isBannerDisplayed]);
  var handleSubmit = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref4) {
      var usernameLogin, passwordLogin, postData, response, data, _t;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            usernameLogin = _ref4.usernameLogin, passwordLogin = _ref4.passwordLogin;
            postData = {
              email: usernameLogin,
              password: passwordLogin
            };
            setLoading(true);
            setIsError(false);
            setErrorMessage(DEFAULT_ERROR_MESSAGE);
            _context.prev = 1;
            _context.next = 2;
            return fetch(LOGIN_ENDPOINT, {
              method: "POST",
              headers: getHeaders(),
              body: _JSON$stringify(postData)
            });
          case 2:
            response = _context.sent;
            _context.next = 3;
            return response.json();
          case 3:
            data = _context.sent;
            if (response.ok && data.successful) {
              successRedirect(data.do_change_password);
              if (data.user_id) {
                sendMessageToIosApp(MessageHandlerNames.UserLogin, {
                  dealroomUserId: data.user_id
                });
              }
            } else {
              setLoading(false);
              setIsError(true);
              if (data.is_locked_out) {
                setErrorMessage(data.message || ACCOUNT_LOCKED_MESSAGE);
              } else if (data.message) {
                setErrorMessage(data.message);
              }
            }
            _context.next = 5;
            break;
          case 4:
            _context.prev = 4;
            _t = _context["catch"](1);
            setIsError(true);
          case 5:
            _context.prev = 5;
            setLoading(false);
            return _context.finish(5);
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 4, 5, 6]]);
    }));
    return function handleSubmit(_x) {
      return _ref5.apply(this, arguments);
    };
  }();
  var handleCheckUser = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref6) {
      var usernameLogin, postData, response, data, _t2;
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            usernameLogin = _ref6.usernameLogin;
            postData = {
              email: usernameLogin
            };
            setLoading(true);
            setIsError(false);
            setErrorMessage(DEFAULT_ERROR_MESSAGE);
            _context2.prev = 1;
            _context2.next = 2;
            return fetch("/ajax/accounts/check_email", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "X-CSRFToken": Cookies.get("csrftoken") || ""
              },
              body: _JSON$stringify(postData)
            });
          case 2:
            response = _context2.sent;
            _context2.next = 3;
            return response.json();
          case 3:
            data = _context2.sent;
            if (response.ok && data.successful) {
              setLoading(false);
              if (data.view !== view) {
                setView(data.view);
              }
              setLoginMethods(data.login_methods);
              if (data.view === IntegrationLoginViews.OTP_WITH_PASSWORD.value || data.view === IntegrationLoginViews.OTP_WITHOUT_PASSWORD.value) {
                setOtpEmail(usernameLogin);
              }
            } else {
              setLoading(false);
              setIsError(true);
              if (data.is_locked_out) {
                setErrorMessage(data.message || ACCOUNT_LOCKED_MESSAGE);
              } else {
                setErrorMessage(data.message || DEFAULT_ERROR_MESSAGE);
              }
            }
            _context2.next = 5;
            break;
          case 4:
            _context2.prev = 4;
            _t2 = _context2["catch"](1);
            setLoading(false);
            setIsError(true);
            setErrorMessage(UNEXPECTED_ERROR_MESSAGE);
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[1, 4]]);
    }));
    return function handleCheckUser(_x2) {
      return _ref7.apply(this, arguments);
    };
  }();
  var emailCheckTimeoutRef = React.useRef(null);
  var isValidEmail = function isValidEmail(email) {
    var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  var handleEmailChange = function handleEmailChange(newEmail) {
    var trimmedEmail = _trimInstanceProperty(newEmail).call(newEmail);
    var previousEmail = emailRef.current;
    setEmail(trimmedEmail);
    emailRef.current = trimmedEmail;
    setShowOTPVerification(false);
    if (emailCheckTimeoutRef.current) {
      clearTimeout(emailCheckTimeoutRef.current);
    }
    emailCheckTimeoutRef.current = _setTimeout(function () {
      if (trimmedEmail && isValidEmail(trimmedEmail) && trimmedEmail !== previousEmail) {
        handleCheckUser({
          usernameLogin: trimmedEmail
        });
      }
    }, 500);
  };
  useEffect(function () {
    return function () {
      if (emailCheckTimeoutRef.current) {
        clearTimeout(emailCheckTimeoutRef.current);
      }
    };
  }, []);
  var handleSignInMethod = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(idp, requestBody) {
      var ssoUrl, headers, response, data, errorData, _t3, _t4;
      return _regeneratorRuntime.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            ssoUrl = "";
            setLoading(true);
            setIsError(false);
            setErrorMessage(DEFAULT_ERROR_MESSAGE);
            headers = {
              "Content-Type": "application/json",
              "X-CSRFToken": Cookies.get("csrftoken") || ""
            };
            _context3.prev = 1;
            _t3 = idp;
            _context3.next = _t3 === IntegrationServicesEnum.OKTA.value ? 2 : _t3 === IntegrationServicesEnum.JLL.value ? 3 : _t3 === IntegrationServicesEnum.GOOGLE.value ? 4 : 5;
            break;
          case 2:
            ssoUrl = "/sso/okta/authorize";
            return _context3.abrupt("continue", 6);
          case 3:
            ssoUrl = "/sso/jll/authorize";
            return _context3.abrupt("continue", 6);
          case 4:
            ssoUrl = "/sso/google/authorize";
            return _context3.abrupt("continue", 6);
          case 5:
            return _context3.abrupt("continue", 6);
          case 6:
            _context3.next = 7;
            return fetch(ssoUrl, {
              method: "POST",
              headers: headers,
              body: _JSON$stringify(requestBody)
            });
          case 7:
            response = _context3.sent;
            if (!response.ok) {
              _context3.next = 9;
              break;
            }
            _context3.next = 8;
            return response.json();
          case 8:
            data = _context3.sent;
            window.location.replace(data === null || data === void 0 ? void 0 : data.url); // open the IDP's login page in the same tab
            setLoading(false);
            setIsError(false);
            _context3.next = 11;
            break;
          case 9:
            _context3.next = 10;
            return response.json();
          case 10:
            errorData = _context3.sent;
            if (errorData.is_locked_out) {
              setErrorMessage(errorData.message || ACCOUNT_LOCKED_MESSAGE);
            } else {
              setErrorMessage(errorData.message || DEFAULT_ERROR_MESSAGE);
            }
            setLoading(false);
            setIsError(true);
          case 11:
            _context3.next = 13;
            break;
          case 12:
            _context3.prev = 12;
            _t4 = _context3["catch"](1);
            setLoading(false);
            setIsError(true);
            setErrorMessage(UNEXPECTED_ERROR_MESSAGE);
          case 13:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[1, 12]]);
    }));
    return function handleSignInMethod(_x3, _x4) {
      return _ref8.apply(this, arguments);
    };
  }();
  var handleOktaSignIn = /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      return _regeneratorRuntime.wrap(function (_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 1;
            return handleSignInMethod(IntegrationServicesEnum.OKTA.value, {
              email: email,
              identity_provider: IntegrationServicesEnum.OKTA.value
            });
          case 1:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function handleOktaSignIn() {
      return _ref9.apply(this, arguments);
    };
  }();
  var handleJllSignIn = /*#__PURE__*/function () {
    var _ref0 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      return _regeneratorRuntime.wrap(function (_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 1;
            return handleSignInMethod(IntegrationServicesEnum.JLL.value, {
              email: email
            });
          case 1:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function handleJllSignIn() {
      return _ref0.apply(this, arguments);
    };
  }();
  var handleGoogleSignIn = /*#__PURE__*/function () {
    var _ref1 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      return _regeneratorRuntime.wrap(function (_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 1;
            return handleSignInMethod(IntegrationServicesEnum.GOOGLE.value, {
              email: email,
              identity_provider: IntegrationServicesEnum.GOOGLE.value
            });
          case 1:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return function handleGoogleSignIn() {
      return _ref1.apply(this, arguments);
    };
  }();
  var successRedirect = function successRedirect(doChangePassword) {
    var search = window.location.search;
    var redirectUrl = getRedirectUrl(doChangePassword, search);
    window.location.assign(redirectUrl);
  };
  var ValidationSchema = Yup.object().shape({
    usernameLogin: Yup.string().nullable().email("Please enter a valid email."),
    passwordLogin: Yup.string().nullable()
  });
  var additionalFormLinks = [{
    id: "forgot_password",
    label: "Forgot password?",
    to: "forgot_password"
  }];
  var alternateSignInMethods = function alternateSignInMethods() {
    var methods = [];
    if (_includesInstanceProperty(loginMethods).call(loginMethods, IntegrationServicesEnum.JLL.value)) {
      methods.push({
        idp: IntegrationServicesEnum.JLL.value,
        label: "Sign in with JLL",
        imgSrc: "".concat(window.STATIC_URL, "images/logos/client_logos/JLL_rings.svg"),
        onClick: handleJllSignIn
      });
    }
    if (_includesInstanceProperty(loginMethods).call(loginMethods, IntegrationServicesEnum.OKTA.value)) {
      methods.push({
        idp: IntegrationServicesEnum.OKTA.value,
        label: "Continue with Okta",
        imgSrc: "".concat(window.STATIC_URL, "images/logos/client_logos/Okta_Aura_Black.svg"),
        onClick: handleOktaSignIn
      });
    }
    if (_includesInstanceProperty(loginMethods).call(loginMethods, IntegrationServicesEnum.GOOGLE.value)) {
      methods.push({
        idp: IntegrationServicesEnum.GOOGLE.value,
        label: "Continue with Google",
        imgSrc: "".concat(window.STATIC_URL, "images/logos/client_logos/google_g.svg"),
        onClick: handleGoogleSignIn
      });
    }
    return methods;
  };
  var getErrorMessageFromCode = function getErrorMessageFromCode(errorCode, defaultMessage) {
    if (!errorCode) {
      return defaultMessage || UNEXPECTED_ERROR_MESSAGE;
    }
    var errorCodesToIgnore = [OTPErrorCodeEnum.INVALID_REQUEST_DATA.value, OTPErrorCodeEnum.INVALID_REQUEST_METHOD.value];
    if (_includesInstanceProperty(errorCodesToIgnore).call(errorCodesToIgnore, errorCode)) {
      var generalError = _valuesInstanceProperty(OTPErrorCodeEnum)[OTPErrorCodeEnum.GENERAL_ERROR.value];
      return (generalError === null || generalError === void 0 ? void 0 : generalError.label) || UNEXPECTED_ERROR_MESSAGE;
    }
    var errorEnum = _valuesInstanceProperty(OTPErrorCodeEnum)[errorCode];
    if (errorEnum && errorEnum.label) {
      return errorEnum.label;
    }
    return defaultMessage || UNEXPECTED_ERROR_MESSAGE;
  };
  var handleRequestOTP = /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      var response, data, _t5;
      return _regeneratorRuntime.wrap(function (_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            setOtpButtonLoading(true);
            setIsError(false);
            setErrorMessage(DEFAULT_ERROR_MESSAGE);
            _context7.prev = 1;
            _context7.next = 2;
            return fetch(REQUEST_OTP_ENDPOINT, {
              method: "POST",
              headers: getHeaders(),
              body: _JSON$stringify({
                email: otpEmail
              })
            });
          case 2:
            response = _context7.sent;
            _context7.next = 3;
            return response.json();
          case 3:
            data = _context7.sent;
            if (response.ok && data.successful) {
              setOtpButtonLoading(false);
              setShowOTPVerification(true);
              setLastResendTime(new Date());
            } else {
              setOtpButtonLoading(false);
              setIsError(true);
              if (data.is_locked_out) {
                setErrorMessage(data.message || ACCOUNT_LOCKED_MESSAGE);
              } else {
                setErrorMessage(getErrorMessageFromCode(data.error_code, data.message || FAILED_TO_GENERATE_OTP_MESSAGE));
              }
            }
            _context7.next = 5;
            break;
          case 4:
            _context7.prev = 4;
            _t5 = _context7["catch"](1);
            setOtpButtonLoading(false);
            setIsError(true);
            setErrorMessage(getErrorMessageFromCode(OTPErrorCodeEnum.GENERAL_ERROR.value, UNEXPECTED_ERROR_MESSAGE));
          case 5:
          case "end":
            return _context7.stop();
        }
      }, _callee7, null, [[1, 4]]);
    }));
    return function handleRequestOTP() {
      return _ref10.apply(this, arguments);
    };
  }();
  var handleVerifyOTP = /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8(otp) {
      var response, data, _t6;
      return _regeneratorRuntime.wrap(function (_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            setLoading(true);
            setIsError(false);
            setErrorMessage(DEFAULT_ERROR_MESSAGE);
            _context8.prev = 1;
            _context8.next = 2;
            return fetch(VERIFY_OTP_ENDPOINT, {
              method: "POST",
              headers: getHeaders(),
              body: _JSON$stringify({
                email: otpEmail,
                otp_code: otp
              })
            });
          case 2:
            response = _context8.sent;
            _context8.next = 3;
            return response.json();
          case 3:
            data = _context8.sent;
            if (response.ok && data.successful === true) {
              window.location.assign("/");
              // disabled until https://jlldigitalproductengineering.atlassian.net/browse/RKG-6261
              // showResetPassword functionality is hidden from users - see Root.tsx for related changes
              // if (data.show_set_password === true) {
              //     window.location.assign("/?showResetPassword=true");
              // } else {
              //     window.location.assign("/");
              // }
            } else {
              setLoading(false);
              setIsError(true);
              if (data.is_locked_out) {
                setErrorMessage(data.message || ACCOUNT_LOCKED_MESSAGE);
              } else {
                setErrorMessage(getErrorMessageFromCode(data.error_code, data.message || INVALID_VERIFICATION_CODE_MESSAGE));
              }
            }
            _context8.next = 5;
            break;
          case 4:
            _context8.prev = 4;
            _t6 = _context8["catch"](1);
            setLoading(false);
            setIsError(true);
            setErrorMessage(getErrorMessageFromCode(OTPErrorCodeEnum.GENERAL_ERROR.value, INVALID_VERIFICATION_CODE_MESSAGE));
          case 5:
          case "end":
            return _context8.stop();
        }
      }, _callee8, null, [[1, 4]]);
    }));
    return function handleVerifyOTP(_x5) {
      return _ref11.apply(this, arguments);
    };
  }();
  var handleResendOTP = /*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
      var now, secondsSinceLastResend, remainingSeconds, response, data, _t7;
      return _regeneratorRuntime.wrap(function (_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            now = new Date();
            if (!lastResendTime) {
              _context9.next = 1;
              break;
            }
            secondsSinceLastResend = Math.floor((now.getTime() - lastResendTime.getTime()) / 1000);
            if (!(secondsSinceLastResend < 30)) {
              _context9.next = 1;
              break;
            }
            remainingSeconds = 30 - secondsSinceLastResend;
            setIsError(true);
            setErrorMessage("Please wait ".concat(remainingSeconds, " seconds before requesting a new code."));
            return _context9.abrupt("return");
          case 1:
            setOtpButtonLoading(true);
            setIsError(false);
            setErrorMessage(DEFAULT_ERROR_MESSAGE);
            _context9.prev = 2;
            _context9.next = 3;
            return fetch(REQUEST_OTP_ENDPOINT, {
              method: "POST",
              headers: getHeaders(),
              body: _JSON$stringify({
                email: otpEmail
              })
            });
          case 3:
            response = _context9.sent;
            _context9.next = 4;
            return response.json();
          case 4:
            data = _context9.sent;
            if (response.ok && data.successful) {
              setOtpButtonLoading(false);
              setLastResendTime(new Date());
            } else {
              setOtpButtonLoading(false);
              setIsError(true);
              if (data.is_locked_out) {
                setErrorMessage(data.message || ACCOUNT_LOCKED_MESSAGE);
              } else {
                setErrorMessage(getErrorMessageFromCode(data.error_code, data.message || FAILED_TO_GENERATE_OTP_MESSAGE));
              }
            }
            _context9.next = 6;
            break;
          case 5:
            _context9.prev = 5;
            _t7 = _context9["catch"](2);
            setOtpButtonLoading(false);
            setIsError(true);
            setErrorMessage(getErrorMessageFromCode(OTPErrorCodeEnum.GENERAL_ERROR.value, UNEXPECTED_ERROR_MESSAGE));
          case 6:
          case "end":
            return _context9.stop();
        }
      }, _callee9, null, [[2, 5]]);
    }));
    return function handleResendOTP() {
      return _ref12.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(GlobalSnackbar, {
      variant: "error",
      message: snackBarMessage,
      onClose: function onClose() {
        return setSnackBarMessage("");
      }
    }), /*#__PURE__*/_jsxs("div", {
      className: classes.container,
      children: [/*#__PURE__*/_jsxs("div", {
        className: classes.loginContentContainer,
        children: [/*#__PURE__*/_jsx("img", {
          src: "".concat(window.STATIC_URL, "images/logos/JLL/JLL Leasing OS Logo.svg"),
          className: classes.loginContentImage
        }), view === IntegrationLoginViews.CHECK_EMAIL.value && /*#__PURE__*/_jsx(WorkplaceLanding, {
          formElements: [{
            id: "usernameLogin",
            initialValue: email,
            label: "Email",
            placeholder: "Enter your email"
          }],
          setEmail: setEmail,
          ValidationSchema: ValidationSchema,
          handleSubmit: handleCheckUser,
          loading: loading,
          isError: isError,
          buttonText: "Continue",
          errorMessage: errorMessage
        }), view === IntegrationLoginViews.BASIC_LOGIN.value && /*#__PURE__*/_jsx(LoginFormContentContainer, {
          header: "Sign in",
          formElements: [{
            id: "usernameLogin",
            initialValue: email,
            label: "Email",
            placeholder: "Enter your email"
          }, {
            id: "passwordLogin",
            initialValue: "",
            label: "Password",
            placeholder: "Enter your password",
            type: "password"
          }],
          ValidationSchema: ValidationSchema,
          handleSubmit: handleSubmit,
          loading: loading,
          isError: isError,
          errorMessage: errorMessage,
          buttonText: "Sign in",
          additionalFormLinks: additionalFormLinks
        }), (view === IntegrationLoginViews.OTP_WITH_PASSWORD.value || view === IntegrationLoginViews.OTP_WITHOUT_PASSWORD.value) && (showOTPVerification ? /*#__PURE__*/_jsx(ErrorBoundary, {
          FallbackComponent: OTPErrorFallback,
          children: /*#__PURE__*/_jsx(WorkplaceOTPVerification, {
            email: otpEmail,
            onBack: function onBack() {
              setShowOTPVerification(false);
              setIsError(false);
            },
            onVerifyOTP: handleVerifyOTP,
            onResendOTP: handleResendOTP,
            loading: loading,
            isError: isError,
            errorMessage: errorMessage
          })
        }) : /*#__PURE__*/_jsx(ErrorBoundary, {
          FallbackComponent: OTPErrorFallback,
          children: /*#__PURE__*/_jsx(WorkplaceLoginFormWithOTP, {
            email: email,
            showPassword: view === IntegrationLoginViews.OTP_WITH_PASSWORD.value,
            loading: loading,
            otpButtonLoading: otpButtonLoading,
            isError: isError,
            errorMessage: errorMessage,
            handleSubmit: handleSubmit,
            handleRequestOTP: handleRequestOTP,
            handleEmailChange: handleEmailChange,
            additionalFormLinks: additionalFormLinks
          })
        })), view === IntegrationLoginViews.ALTERNATE_LOGIN.value && /*#__PURE__*/_jsx(WorkplaceAlternateSignIns, {
          isError: isError,
          errorMessage: errorMessage,
          additionalFormLinks: [],
          alternateSignInMethods: alternateSignInMethods(),
          setView: setView
        })]
      }), !isMobile ? /*#__PURE__*/_jsx("img", {
        className: classes.stockImage,
        src: "".concat(window.STATIC_URL, "images/JLL Login Workspace Cover.jpg")
      }) : null]
    })]
  });
};
export default WorkplaceLogin;